/* acc_pd_lp_05_01 — behaviour for the LP 05 landing page. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.acc_pd_lp_05_01';
  var instances = [];

  /* ------------------------------------------------------------- reveal -- */

    /* One observer for the whole page. */
  function initReveal(scope) {
    var targets = Array.prototype.slice.call(
      scope.querySelectorAll('.pd05-reveal:not([data-pd05-reveal-bound])')
    );
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-in');
        el.setAttribute('data-pd05-reveal-bound', '');
      });
      return;
    }

        /* Read every rect first, then write every class. */
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    var immediate = targets.map(function (el) {
      var r = el.getBoundingClientRect();
            /* Above the fold, or already scrolled past. */
      return r.top < viewportH * 0.9;
    });

    targets.forEach(function (el, i) {
      el.setAttribute('data-pd05-reveal-bound', '');
      if (immediate[i]) el.classList.add('is-in');
    });

    var pending = targets.filter(function (el, i) {
      return !immediate[i];
    });
    if (!pending.length) return;

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );

    pending.forEach(function (el) {
      io.observe(el);
    });
    instances.push({ destroy: function () { io.disconnect(); } });
  }

  /* ------------------------------------------------------------ sliders -- */

    /* Each slider carries its own breakpoint in data-pd05-slider-max. */
  function initSliders(scope) {
    var nodes = Array.prototype.slice.call(
      scope.querySelectorAll('[data-pd05-slider]:not([data-pd05-slider-bound])')
    );
    if (!nodes.length) return;

    if (typeof window.Swiper !== 'function') return;

    nodes.forEach(function (el) {
      el.setAttribute('data-pd05-slider-bound', '');

      var max = parseInt(el.getAttribute('data-pd05-slider-max'), 10);
      var mq = window.matchMedia('(max-width: ' + (max || 767) + 'px)');
      var swiper = null;

      function build() {
        if (swiper) return;
        /* The nav is a sibling of the slider root, not a child: at 1200 the root
           becomes `display: contents` and anything inside it joins the grid. */
        var nav = el.parentElement && el.parentElement.querySelector('.pd05-slider-nav');
        swiper = new window.Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 16,
          /* Stops at the first and last slide rather than wrapping. */
          loop: false,
          grabCursor: true,
          watchOverflow: true,
          threshold: 8,
          speed: 380,
          a11y: { enabled: true, prevSlideMessage: 'Previous', nextSlideMessage: 'Next' },
          keyboard: { enabled: true, onlyInViewport: true },
          pagination: nav
            ? { el: nav.querySelector('.pd05-slider-nav__rail'), type: 'progressbar' }
            : false,
          navigation: nav
            ? {
              prevEl: nav.querySelector('.pd05-slider-nav__btn--prev'),
              nextEl: nav.querySelector('.pd05-slider-nav__btn--next')
            }
            : false
        });
      }

      function teardown() {
        if (!swiper) return;
        swiper.destroy(true, true);
        swiper = null;
      }

      function sync() {
        if (mq.matches) build();
        else teardown();
      }

      sync();

            /* addEventListener on a MediaQueryList is the modern form; Safari below 14 only has. */
      if (typeof mq.addEventListener === 'function') mq.addEventListener('change', sync);
      else if (typeof mq.addListener === 'function') mq.addListener(sync);

      instances.push({
        destroy: function () {
          teardown();
          if (typeof mq.removeEventListener === 'function') mq.removeEventListener('change', sync);
          else if (typeof mq.removeListener === 'function') mq.removeListener(sync);
        }
      });
    });
  }

  /* ------------------------------------------------------- sticky CTA -- */

    /* Ported from LP 01's initStickyBar. */
  function initSticky(scope) {
    var bar = scope.querySelector('[data-pd05-sticky]:not([data-pd05-sticky-bound])');
    if (!bar) return;
    bar.setAttribute('data-pd05-sticky-bound', '');

    var root = bar.closest(ROOT_SELECTOR) || document;
    var state = { passedHero: false, atFinal: false };
    var visible = null;

    function apply() {
      var show = state.passedHero && !state.atFinal;
      if (show === visible) return;
      visible = show;
      bar.classList.toggle('is-visible', show);
            /* aria-hidden tracks the visual state, so the bar is not announced while it is off screen. */
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    var trigger = root.querySelector('[data-pd05-sticky-trigger]');

    if (!trigger || !('IntersectionObserver' in window)) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.setTimeout(function () {
          ticking = false;
          state.passedHero = window.pageYOffset > window.innerHeight * 0.6;
          apply();
        }, 150);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      instances.push({ destroy: function () { window.removeEventListener('scroll', onScroll); } });
      onScroll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        state.passedHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        apply();
      });
    }, { threshold: 0 });
    io.observe(trigger);
    instances.push({ destroy: function () { io.disconnect(); } });

        /* LP 01 pointed at a fixed element id. */
    if (bar.hasAttribute('data-pd05-sticky-hide-at-final')) {
      var hideAt = root.querySelector('[data-pd05-final-cta]');
      if (hideAt) {
        var io2 = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { state.atFinal = entry.isIntersecting; apply(); });
        }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });
        io2.observe(hideAt);
        instances.push({ destroy: function () { io2.disconnect(); } });
      }
    }

    apply();
  }

  /* ---------------------------------------------------------------- boot -- */

  function boot(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll(ROOT_SELECTOR), function (el) {
      el.classList.add('acc_pd_lp_05_01--js');
    });
    if (root !== document && root.matches && root.matches(ROOT_SELECTOR)) {
      root.classList.add('acc_pd_lp_05_01--js');
    }
    initReveal(root);
    initSliders(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

    /* The theme editor swaps section markup in and out without a page load. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(ROOT_SELECTOR)) {
      boot(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelector || !e.target.querySelector(ROOT_SELECTOR)) return;
    instances.forEach(function (inst) {
      try {
        inst.destroy();
      } catch (err) {
        /* A destroyed Swiper can throw on a second teardown. Nothing to recover. */
      }
    });
    instances = [];
  });
})();
